/* 18 Oct 2026 - heart (save) + quick add sheet for product cards. Plain JS, no dependencies.
   Saved list = localStorage 'asc_saved_v1' (array of product handles). Quick add reuses the theme's own <product-form>
   so the cart drawer, errors and analytics behave exactly like the product page. */
(function () {
  if (window.__ascCA) return;
  window.__ascCA = 1;
  var KEY = 'asc_saved_v1';
  var cache = {};

  function getSaved() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function setSaved(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} paint(); document.dispatchEvent(new CustomEvent('asc:saved')); }
  function paint() {
    var s = getSaved();
    document.querySelectorAll('[data-asc-heart]').forEach(function (b) { b.setAttribute('aria-pressed', s.indexOf(b.getAttribute('data-asc-heart')) > -1 ? 'true' : 'false'); });
    document.querySelectorAll('[data-asc-saved-count]').forEach(function (c) { var n = String(s.length); if (c.textContent !== n) c.textContent = n; c.hidden = !s.length; });
  }
  function toggle(h) {
    var s = getSaved(), i = s.indexOf(h);
    if (i > -1) s.splice(i, 1); else s.push(h);
    setSaved(s);
  }

  /* ---------- sheet ---------- */
  var sheet, panel, body, state = {};
  function ensure() {
    if (sheet) return true;
    sheet = document.getElementById('AscQuickSheet');
    if (!sheet) return false;
    panel = sheet.querySelector('.asc-qs__panel');
    body = sheet.querySelector('.asc-qs__body');
    return true;
  }
  function S(k) { return sheet.getAttribute('data-s-' + k) || ''; }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function close() {
    if (!sheet) return;
    sheet.hidden = true; document.body.classList.remove('asc-qs-open');
    if (state.opener && state.opener.focus) { try { state.opener.focus(); } catch (e) {} }
  }
  function openFor(handle, opener) {
    if (!ensure()) return;
    state = { handle: handle, opener: opener, card: opener.closest('.card-wrapper') };
    body.innerHTML = '<div class="asc-qs__load">…</div>';
    sheet.hidden = false; document.body.classList.add('asc-qs-open');
    panel.focus();
    var root = (sheet.getAttribute('data-root') || '/').replace(/\/?$/, '/');
    var url = root + 'products/' + handle + '.js';
    (cache[handle] ? Promise.resolve(cache[handle]) : fetch(url).then(function (r) { return r.json(); }).then(function (p) { cache[handle] = p; return p; }))
      .then(build).catch(function () { location.href = root + 'products/' + handle; });
  }
  function optIndex(p, re) { for (var i = 0; i < p.options.length; i++) { var n = (p.options[i].name || p.options[i]) + ''; if (re.test(n)) return i; } return -1; }
  function build(p) {
    var root = (sheet.getAttribute('data-root') || '/').replace(/\/?$/, '/');
    var ci = optIndex(p, /colou?r|لون/i), si = optIndex(p, /size|مقاس/i);
    if (si < 0 && p.options.length === 1 && ci !== 0) si = 0;
    var cols = [], seen = {};
    if (ci > -1) p.variants.forEach(function (v) { var k = v.options[ci]; if (!seen[k]) { seen[k] = 1; cols.push({ name: k, img: (v.featured_image && v.featured_image.src) || p.featured_image }); } });
    var priceNode = state.card && state.card.querySelector('.card-price .price');
    var priceHtml = priceNode ? priceNode.innerHTML : '';
    state.p = p; state.ci = ci; state.si = si;
    state.colour = cols.length ? cols[0].name : null;
    state.size = null;
    var h = '<div class="asc-qs__top"><img class="asc-qs__img" alt="" src="' + esc(thumb(p.featured_image, 240)) + '" data-asc-qs-img><div><h3 class="asc-qs__title">' + esc(p.title) + '</h3><div class="asc-qs__price"><span class="price">' + priceHtml + '</span></div></div><button type="button" class="asc-qs__x" data-asc-qs-close aria-label="' + esc(S('close')) + '">×</button></div>';
    if (cols.length > 1) {
      h += '<div class="asc-qs__row"><p class="asc-qs__lab">' + esc(S('colour')) + ': <b data-asc-qs-colname>' + esc(state.colour) + '</b></p><div class="asc-qs__chips">';
      cols.forEach(function (c, i) { h += '<button type="button" class="asc-qs__col" data-asc-qs-col="' + esc(c.name) + '" aria-label="' + esc(c.name) + '" aria-pressed="' + (i === 0) + '" style="background-image:url(\'' + esc(thumb(c.img, 120)) + '\')"></button>'; });
      h += '</div></div>';
    }
    if (si > -1) h += '<div class="asc-qs__row"><p class="asc-qs__lab">' + esc(S('size')) + '</p><div class="asc-qs__chips" data-asc-qs-sizes></div><a class="asc-qs__help" href="' + root + 'products/' + p.handle + '?sb=1">' + esc(S('find')) + '</a></div>';
    h += '<product-form class="asc-qs__pf"><form method="post" action="' + root + 'cart/add" enctype="multipart/form-data" class="form" novalidate data-type="add-to-cart-form"><input type="hidden" name="id" value="" class="product-variant-id"><input type="hidden" name="quantity" value="1"><button type="submit" class="asc-qs__go" aria-disabled="false"><span>' + esc(S('add')) + '</span><span class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></span></button></form><div class="product-form__error-message-wrapper asc-qs__err" role="alert" hidden><span class="product-form__error-message"></span></div></product-form>';
    h += '<a class="asc-qs__full" href="' + root + 'products/' + p.handle + '">' + esc(S('full')) + '</a>';
    body.innerHTML = h;
    sizes(); pickDefault();
  }
  function thumb(src, w) { if (!src) return ''; return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2'); }
  function variantsFor(colour) {
    var p = state.p;
    return p.variants.filter(function (v) { return state.ci < 0 || v.options[state.ci] === colour; });
  }
  function sizes() {
    var wrap = body.querySelector('[data-asc-qs-sizes]'); if (!wrap) return;
    var vs = variantsFor(state.colour), h = '';
    vs.forEach(function (v) {
      var label = v.options[state.si];
      h += '<button type="button" class="asc-qs__sz" data-asc-qs-sz="' + v.id + '" aria-pressed="false"' + (v.available ? '' : ' disabled title="' + esc(S('sold')) + '"') + '>' + esc(label) + '</button>';
    });
    wrap.innerHTML = h; state.size = null; setVariant(null);
    // one size only and it is available: select it so the shopper can add in one tap
    var av = vs.filter(function (v) { return v.available; });
    if (av.length === 1 && vs.length === 1) { selectSize(av[0].id); }
  }
  function pickDefault() { /* nothing preselected on purpose: the shopper chooses the size (fit matters) */ }
  function setVariant(id) {
    var inp = body.querySelector('input[name=id]'); if (inp) inp.value = id || '';
  }
  function selectSize(id) {
    state.size = id; setVariant(id);
    body.querySelectorAll('[data-asc-qs-sz]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-asc-qs-sz')) === String(id)); });
  }
  function selectColour(name, btn) {
    state.colour = name;
    body.querySelectorAll('[data-asc-qs-col]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn); });
    var l = body.querySelector('[data-asc-qs-colname]'); if (l) l.textContent = name;
    var c = null; state.p.variants.forEach(function (v) { if (!c && v.options[state.ci] === name && v.featured_image) c = v.featured_image.src; });
    var img = body.querySelector('[data-asc-qs-img]'); if (img && c) img.src = thumb(c, 240);
    sizes();
  }

  /* The theme's whole-card link (a::after) sits above our buttons in hit-testing, so a tap on a button lands on the link.
     Fix: in the capture phase, if the tap is inside a card's button rectangle, treat the target as that button. */
  function realTarget(e) {
    var t = e.target;
    if (!t || !t.closest || e.clientX == null) return t;
    var card = t.closest('.product-card-wrapper');
    if (!card) return t;
    var btns = card.querySelectorAll('[data-asc-heart],[data-asc-add]');
    for (var i = 0; i < btns.length; i++) {
      var r = btns[i].getBoundingClientRect();
      if (r.width && e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) return btns[i];
    }
    return t;
  }
  document.addEventListener('click', function (e) {
    var t = realTarget(e);
    var heart = t.closest && t.closest('[data-asc-heart]');
    if (heart) { e.preventDefault(); e.stopPropagation(); toggle(heart.getAttribute('data-asc-heart')); return; }
    var add = t.closest && t.closest('[data-asc-add]');
    if (add) { e.preventDefault(); e.stopPropagation(); openFor(add.getAttribute('data-asc-add'), add); return; }
    if (!sheet || sheet.hidden) return;
    if (t.closest('[data-asc-qs-close]')) { close(); return; }
    var col = t.closest('[data-asc-qs-col]'); if (col) { selectColour(col.getAttribute('data-asc-qs-col'), col); return; }
    var sz = t.closest('[data-asc-qs-sz]'); if (sz && !sz.disabled) { selectSize(sz.getAttribute('data-asc-qs-sz')); return; }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && !sheet.hidden) close(); });
  /* the theme's product-form handles the submit; we only stop an add with no size and close the sheet when it goes through */
  document.addEventListener('submit', function (e) {
    if (!sheet || !e.target.closest || !e.target.closest('.asc-qs__pf')) return;
    var id = e.target.querySelector('[name=id]').value;
    if (!id) {
      e.preventDefault(); e.stopImmediatePropagation();
      var wrap = body.querySelector('[data-asc-qs-sizes]');
      if (wrap) { wrap.querySelectorAll('.asc-qs__sz').forEach(function (b) { b.classList.remove('is-need'); void b.offsetWidth; b.classList.add('is-need'); }); }
      var er = body.querySelector('.asc-qs__err'); if (er) { er.hidden = false; er.querySelector('.product-form__error-message').textContent = S('choose'); }
      return;
    }
    setTimeout(close, 450);
  }, true);

  function boot() { paint(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', paint);
  window.addEventListener('storage', paint);
  new MutationObserver(function () { clearTimeout(boot._t); boot._t = setTimeout(paint, 80); }).observe(document.documentElement, { childList: true, subtree: true });
})();
